import { QUERY_PARAMETER } from './query-params'

export const REDUX_KEY = {
  DATA: 'data',
  ERROR: 'error',
  STATUS: 'status',
  VALIDATION: 'validation',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  VIEWED_AT: 'viewedAt'
}

export const REDUX_MODEL_KEY = {
  ...REDUX_KEY,
  CHANGED: 'changed',
  CLASS_NAME: 'className',
  CID: 'cid'
}

export const REDUX_DOMAIN_LIST_KEY = {
  ...REDUX_KEY,
  LAST_ID: QUERY_PARAMETER.LAST_ID,
  ALL: 'all'
}

export const REDUX_DOMAIN_LIST_SECTION_KEY = {
  BY_PROFILE_ID: 'byProfileId',
  BY_YEAR: 'byYear',
  BY_MONTH: 'byMonth',
  BY_WEEK: 'byWeek',
  BY_DAY: 'byDay',
  BY_QUERY: 'byQuery'
}

export const REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT = {
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day'
}

export const REDUX_DOMAIN_LIST_SECTION_DATE_KEYS = [
  REDUX_DOMAIN_LIST_SECTION_KEY.BY_YEAR,
  REDUX_DOMAIN_LIST_SECTION_KEY.BY_MONTH,
  REDUX_DOMAIN_LIST_SECTION_KEY.BY_WEEK,
  REDUX_DOMAIN_LIST_SECTION_KEY.BY_DAY
]
